import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as pageActions from "redux/actions/pageActions";
import TmeHome from "./TmeHome";
import {
  FILTER_STORAGE_KEY,
  readStoredFilters,
  buildHomeFilterRequest,
} from "./components/Charts/homeFilters";

const Home = () => {
  const dispatch = useDispatch();
  const [isloading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const selectedClient = useSelector(state => state.clients.selectedClient);
  const selectedClientId = useSelector(state => state.clients.selectedClientId);

  useEffect(() => {
    if (selectedClient?.clientId) {
      setLoading(true);
      // Seeded from whatever filters this session already had persisted for Home
      // (see useSessionFilters) so a returning-within-session user doesn't see their
      // filters silently reset to "no filter" on the very first load.
      const requestBody = buildHomeFilterRequest(
        selectedClient.clientId,
        readStoredFilters(FILTER_STORAGE_KEY)
      );
      dispatch(pageActions.getHomePageData(requestBody))
        .catch(e => {
          setError(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, selectedClientId, selectedClient]);

  return <TmeHome isloading={isloading} />;
}
export default Home;
